module.exports = __webpack_public_path__ + "static/media/email.4d11fa37.svg";